// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"editCreate_formContainer__12TqQ","form":"editCreate_form__2hz1f"};